import type { BrandVariants } from "@fluentui/react-components";

/**
 * BAE brand colours, taken from baeinfotech.com rather than invented here.
 *
 *   navy    #0A1A3A  the logo navy
 *   accent  #1A8FFF  electric blue
 *   royal   #2F6BFF
 *   cyan    #5FD0FF
 */
export const baeColours = {
  navy: "#0A1A3A",
  accent: "#1A8FFF",
  royal: "#2F6BFF",
  cyan: "#5FD0FF",
} as const;

/**
 * Fluent's 16-step brand ramp, generated from the BAE electric blue at hue 209°
 * so that key 80 is exactly `#1A8FFF`. Key 10 is darkest, 160 lightest.
 *
 * Saturation is eased off at both ends so the pale steps do not turn milky and the
 * dark steps land near the BAE navy instead of a generic near-black.
 */
export const baeBrandRamp: BrandVariants = {
  10: "#091725",
  20: "#0B2741",
  30: "#0C365F",
  40: "#0A4680",
  50: "#0756A2",
  60: "#0366C4",
  70: "#007AF0",
  80: "#1A8FFF",
  90: "#3DA0FF",
  100: "#5EAFFD",
  110: "#7FBEFA",
  120: "#9FCDF9",
  130: "#BEDCF9",
  140: "#D7E8F9",
  150: "#EAF2FA",
  160: "#F5F9FC",
};

/**
 * Semantic colours for operational state. Deliberately outside the brand ramp: "this
 * product failed to sync" must not be a shade of the brand, or the reader has to work out
 * whether blue means brand or means information.
 *
 * Hues are pulled away from the brand's 209° so they stay distinguishable beside it, and
 * each has a light-theme and dark-theme value because a single value never reads on both.
 */
export const baeSemantic = {
  light: {
    successForeground: "#0E6B45",
    successBackground: "#E4F3EC",
    warningForeground: "#8A5A05",
    warningBackground: "#FBEEDA",
    dangerForeground: "#A32B22",
    dangerBackground: "#F9E4E2",
    infoForeground: "#0366C4",
    infoBackground: "#EAF2FA",
  },
  dark: {
    successForeground: "#5CCB96",
    successBackground: "#13301F",
    warningForeground: "#E3AE52",
    warningBackground: "#33270F",
    dangerForeground: "#F08479",
    dangerBackground: "#381916",
    infoForeground: "#7FBEFA",
    infoBackground: "#122236",
  },
} as const;
